import React from 'react';
import { useDropzone } from 'react-dropzone';
import './Uploads.scss';
import Error from './Error/Error';

export default function FileUpload({
    formik,
    singleImage = false,
    label,
    dropzoneText,
    fieldName = 'docs'
}) {
    const uploadedFiles = formik.values[fieldName];
    const setUploadedFiles = (files) => formik.setFieldValue(fieldName, files);

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'application/pdf': ['.pdf'],
            'application/rtf': ['.rtf'],
            'text/plain': ['.txt'],
            'application/vnd.oasis.opendocument.text': ['.odt'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
        },
        maxSize: 8 * 1024 * 1024,
        onDrop: (acceptedFiles, fileRejections) => {
            if (fileRejections.length > 0) {
                formik.setFieldError(fieldName, 'Only PDFs or word documents are supported. The file must be less than 8MB.');
                return;
            }

            let newFiles;
            if (singleImage) {
                newFiles = acceptedFiles.slice(0, 1).map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                );
            } else {
                newFiles = [...uploadedFiles, ...acceptedFiles.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                )];
            }

            setUploadedFiles(newFiles);
        }
    });

    const removeImage = (index) => {
        const newFiles = [...uploadedFiles];
        URL.revokeObjectURL(newFiles[index].preview);
        newFiles.splice(index, 1);
        setUploadedFiles(newFiles);
    };


    return (
        <div className={label && "meatex-form-row"}>
            {label && <label>{label}</label>}

            {(!singleImage || (singleImage && uploadedFiles.length === 0)) && (
                <div {...getRootProps()} className="file-upload__drop">
                    <input {...getInputProps()} />
                    <p>{dropzoneText || "Drag & drop your CV here, or click to select it"}</p>
                </div>
            )}

            {uploadedFiles.length > 0 && (
                <div className="file-upload__thumbs">
                    {uploadedFiles.map((file, index) => (
                        <div key={index} style={{ marginRight: '10px', position: 'relative' }}>
                            <div className="file-upload__file">
                                {file.name}
                            </div>
                            <button
                                className="file-upload__remove"
                                aria-label="Remove"
                                onClick={() => removeImage(index)}
                            >
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <Error touched={true} error={formik.errors[fieldName]} />
        </div>
    );
};